/**
 * Root route — Postopia staff surface at q.postopia.com.
 *
 * Authentication is handled at the perimeter by Cloudflare Access
 * (Zitadel OIDC backend; see infra/Q-INFRA.md). By the time this
 * component renders in the browser, CF Access has already verified
 * the user's Zitadel identity and set a CF Access cookie. The SPA
 * does NOT validate or refresh that session — the cookie is HttpOnly,
 * managed by Cloudflare's edge, and inaccessible to client JS.
 *
 * Identity (who am I) is fetched on-demand from admin-worker's
 * `/api/me` endpoint, which reads the `CF-Access-Authenticated-User-
 * Email` header that CF Access injects on same-origin requests.
 * That wiring lands with the daemon-proxy work; for now the chrome
 * just renders without a "current user" affordance.
 *
 * In local dev (`pnpm dev`, no VITE_API_URL set), there's no CF
 * Access in front. The page just loads. That's the demo-mode shape.
 */

import { Outlet, createRootRoute } from '@tanstack/react-router';

function RootLayout() {
  return <Outlet />;
}

export const Route = createRootRoute({
  component: RootLayout,
});
